import { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from '../services/AuthService';

export function useSecurity() {
  const navigate = useNavigate();

  const forceLogout = useCallback((reason = 'security') => {
    logout();
    setTimeout(() => navigate('/', { replace: true }), 100);
  }, [navigate]);

  useEffect(() => {
    // In development, skip aggressive security checks
    if (process.env.NODE_ENV === 'development') return;

    const disableContextMenu = (e) => { e.preventDefault(); return false; };
    document.addEventListener('contextmenu', disableContextMenu);

    // Block devtools-opening shortcuts only — Ctrl+C/V/X intentionally NOT blocked
    const blockShortcuts = (e) => {
      const triggers = [
        e.key === 'F12',
        e.ctrlKey && e.shiftKey && e.key === 'I',
        e.ctrlKey && e.shiftKey && e.key === 'J',
        e.ctrlKey && e.shiftKey && e.key === 'C',
        e.ctrlKey && e.shiftKey && e.key === 'K',
        e.ctrlKey && e.key === 'u',
        e.ctrlKey && e.key === 's',
      ];
      if (triggers.some(Boolean)) {
        // Block the shortcut but do NOT log the user out (avoids killing a live
        // interview on an accidental F12 / Ctrl+S / Ctrl+U keypress)
        e.preventDefault();
        return false;
      }
    };
    document.addEventListener('keydown', blockShortcuts);

    return () => {
      document.removeEventListener('contextmenu', disableContextMenu);
      document.removeEventListener('keydown', blockShortcuts);
    };
  }, [forceLogout]);
}

